export default __webpack_public_path__ + "static/media/public.6c08b35f.svg";